import { LinearGradient } from 'expo-linear-gradient'
import React from 'react'
import { TouchableOpacity, View, ViewStyle } from 'react-native'
import { ModalProps } from 'react-native-modal'
import { useThrottledCallback } from 'use-debounce'

import { CommonModal } from '../CommonModal/commonModal'
import { Text } from '../text/text'
import { styles } from './styles'

export interface ActionModalProps extends Partial<ModalProps> {
  stack?: number
  visible: boolean
  message: string
  buttonTitle1?: string
  buttonTitle2?: string
  onAction?: () => void
  onClose: () => void
  shouldHideSecondButton?: boolean
  type?: string
  onSelect?: (key: string) => void
  actionOnDeny?: () => void
  btnStyle?: ViewStyle
}

export const ActionModal = (props: ActionModalProps) => {
  const {
    visible,
    onAction,
    onClose,
    message,
    stack,
    buttonTitle1,
    buttonTitle2,
    shouldHideSecondButton,
    type,
    onSelect,
    actionOnDeny,
    btnStyle,
    ...rest
  } = props

  const onPress = useThrottledCallback(() => {
    onAction?.()
    onClose()
  }, 500)

  const modalContent = () => {
    const stackValue = stack ? `${stack}?` : ''
    return (
      <View style={{ paddingHorizontal: 20, paddingBottom: 31, backgroundColor: 'white', borderRadius: 6 }}>
        <Text
          allowFontScaling={false}
          tx="gameScreen.actionModal.title"
          txOptions={{ message: message, stackValue: stackValue }}
          style={[styles.modalTitle, { color: '#000', paddingHorizontal: 5 }]}
        />
        <TouchableOpacity onPress={onPress} style={styles.button1}>
          <LinearGradient
            colors={btnStyle?.backgroundColor ? ['#5BC4FF', '#5BC4FF'] : ['#2d50d9', '#5025a9']}
            start={[0, 1]}
            end={[1, 0]}
            style={{ flex: 1, borderRadius: 6 }}
          >
            <Text
              allowFontScaling={false}
              tx={!buttonTitle1 ? 'common.yes' : 'common.label'}
              txOptions={!buttonTitle1 ? {} : { label: buttonTitle1 }}
              style={styles.buttonText}
            />
          </LinearGradient>
        </TouchableOpacity>
        {shouldHideSecondButton !== true && (
          <TouchableOpacity
            onPress={(e) => {
              e.preventDefault()
              onClose()
              actionOnDeny?.()
            }}
            style={[styles.button2, { backgroundColor: btnStyle?.backgroundColor ?? '#B6B6B6' }]}
          >
            <Text
              allowFontScaling={false}
              tx={!buttonTitle2 ? 'common.no' : 'common.label'}
              txOptions={!buttonTitle2 ? {} : { label: buttonTitle2 }}
              style={styles.buttonText}
            />
          </TouchableOpacity>
        )}
      </View>
    )
  }

  const modalContentUserRole = () => {
    const stackValue = stack ? `${stack}?` : ''
    return (
      <View style={{ paddingHorizontal: 20, paddingBottom: 31, backgroundColor: 'white', borderRadius: 6 }}>
        <Text
          allowFontScaling={false}
          tx="gameScreen.actionModal.title"
          txOptions={{ message: message, stackValue: stackValue }}
          style={[styles.modalTitle, { color: '#000', paddingHorizontal: 5 }]}
        />
        <TouchableOpacity onPress={() => onSelect?.('observer')} style={styles.button1}>
          <LinearGradient
            colors={['#5BC4FF', '#5BC4FF']}
            start={[0, 1]}
            end={[1, 0]}
            style={{ flex: 1, borderRadius: 6 }}
          >
            <Text
              allowFontScaling={false}
              tx={!buttonTitle1 ? 'common.yes' : 'common.label'}
              txOptions={!buttonTitle1 ? {} : { label: buttonTitle1 }}
              style={styles.buttonText}
            />
          </LinearGradient>
        </TouchableOpacity>
        <TouchableOpacity onPress={() => onSelect?.('player')} style={styles.button1}>
          <LinearGradient
            colors={['#5BC4FF', '#5BC4FF']}
            start={[0, 1]}
            end={[1, 0]}
            style={{ flex: 1, borderRadius: 6 }}
          >
            <Text
              allowFontScaling={false}
              tx={!buttonTitle2 ? 'common.yes' : 'common.label'}
              txOptions={!buttonTitle2 ? {} : { label: buttonTitle2 }}
              style={styles.buttonText}
            />
          </LinearGradient>
        </TouchableOpacity>
      </View>
    )
  }

  return (
    <CommonModal
      {...rest}
      visible={visible}
      onClose={onClose}
      showCloseButton={false}
      containerStyle={{ borderRadius: 6 }}
    >
      {type !== 'userRole' ? modalContent() : modalContentUserRole()}
    </CommonModal>
  )
}
